// extracted by mini-css-extract-plugin
module.exports = {"container":"search-bar-m__container__1qzzs","search-input":"search-bar-m__search-input__3LDrT"};